import { combineReducers } from '@reduxjs/toolkit';
import { quiz } from './quizSlice';
import { quizLibrary } from './quizLibrary';
import { quizAdmin } from './quizAdmin';
import { quizAdminV2 } from './quizAdminV2';
import { quizSharedByAdminV2 } from './quizSharedByAdminV2';
import { quizMyV2 } from './quizMyV2';
import { quizSharedByMeV2 } from './quizSharedByMeV2';
import { tags } from './tag/tagSlice';
import { quizCustomer } from "./quizCustomer";
import { quizCustomerV2 } from "./quizCustomerV2";
import { quizUser } from "./quizUser";

export const quizzes = combineReducers({
    quiz,
    tags,
    quizLibrary,
    quizAdmin,
    quizAdminV2,
    quizSharedByAdminV2,
    quizMyV2,
    quizSharedByMeV2,
    quizCustomer,
    quizCustomerV2,
    quizUser
});